import React from 'react'

const WarningSvg = ({ className = "warning-svg" }) => {
  return (
    <svg className={className} width="49" height="44" viewBox="0 0 49 44" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path id="Polygon 7" d="M47.0922 37.5556C48.2508 39.5309 46.8026 42 44.4854 42H4.51456C2.19741 42 0.749188 39.5309 1.90776 37.5556L21.8932 3.48148C23.0518 1.50617 25.9482 1.50617 27.1068 3.48148L40.7201 26.6914M24.4998 15.8272V30.1481M24.4998 32.6173V35.5802" stroke="#1E2329" strokeWidth="3" />
    </svg>
  )
}
export default WarningSvg